import React from "react";
import { FiArrowLeft, FiBookOpen } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import vaisnavaPdf from "../../Assets/Boys premarital course(bengali).pdf";

const VaisnavaCourse = () => {
  const navigate = useNavigate();

  const handleOpenForm = () => {
    window.location.href = "https://docs.google.com/forms/d/e/1FAIpQLScojke4V-V_wHBoMyTOt1Bel58tHrpJaigVb8rDAHuUuFmIKA/viewform";
  };

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-start bg-gradient-to-br from-purple-100 via-pink-100 to-yellow-100 p-1 md:p-4">
      
      <div className="relative mt-4 md:mt-10 w-[98%] md:w-[95%] lg:w-[90%] rounded-xl bg-white p-2 md:p-4 shadow-2xl">
        
    
        <div className="flex items-center justify-between mb-2 p-2 md:p-4">
       
          <button
            onClick={() => navigate(-1)}
            className="hidden md:flex items-center space-x-1 text-gray-700 hover:text-gray-900 transition-colors"
          >
            <FiArrowLeft size={20} />
            <span className="text-sm font-bold">Back</span>
          </button>

          <h2 className="text-sm md:text-xl font-extrabold text-gray-800 w-full md:w-auto text-center md:text-right truncate">
          Premarital Course (Boys) Preview
          </h2>
        </div>
        <div className="overflow-hidden rounded-lg border border-gray-300 bg-gray-50">
          <iframe
            src={`${vaisnavaPdf}#view=FitW`} 
            title="Course PDF"
            className="w-full h-[75vh] md:h-[80vh] border-none block"
          />
        </div>
        <div className="mt-4 flex justify-center pb-2">
          <button 
            onClick={handleOpenForm} 
            className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition-all active:scale-95"
          >
            <FiBookOpen />
            Open Registration Form
          </button>
        </div>
      </div>
    </div>
  );
};

export default VaisnavaCourse;